export default __webpack_public_path__ + "static/media/circle.9e6f014e.png";